import { render } from "./NavElement.vue?vue&type=template&id=21172b24"
import script from "./NavElement.vue?vue&type=script&lang=js"
export * from "./NavElement.vue?vue&type=script&lang=js"
script.render = render

export default script